<script lang="ts">
  import { resolveContent } from "$lib/content/registry";
  import PageContainer from '$lib/components/PageContainer.svelte';
  import type { PageData } from './$types';

  let { data }: { data: PageData } = $props();

  // Use the proper dynamic content registry
  const Component = resolveContent('about', data.brand);
</script>

<svelte:head>
  <title>About - {data.config.displayName}</title>
  <meta name="description" content="Learn more about {data.config.displayName} and our mission to help you succeed." />
  <meta property="og:title" content="About - {data.config.displayName}" />
  <meta property="og:type" content="website" />
</svelte:head>

<PageContainer config={data.config}>
  {#if Component}
    <svelte:component this={Component} data={data} />
  {:else}
    <div class="error-container">
      <h1>Content Not Found</h1>
      <p>The about page content could not be loaded.</p>
    </div>
  {/if}
</PageContainer>
